<template>
  <div>
    <div v-for="(trip, index) in filterdCartTrips" :key="trip.id">
      <div
        class="cart-item-toggle"
        role="button"
        data-toggle="collapse"
        :data-target="'#cart-trip-' + index"
        aria-expanded="false"
        :aria-controls="'cart-trip-' + index"
      >
        <span class="cart-item--text">
          <i :class="['fa', getTripTicketsProductIcon(trip.from, trip.to)]"></i>
          {{ $t("trip") }}: {{ trip.from }} {{ $t("tocart") }} {{ trip.to }}
          <span
            ><small
              ><i class="fa fa-map"></i> {{ $t("showitinirary") }}</small
            ></span
          >
        </span>
        <span class="cart-item--price pull-right">{{
          getTripTickets(trip.from, trip.to) | totalPrice
        }}  <a href="#" @click.prevent="removeFromCart(getTripTickets(trip.from,trip.to)[0].operationId)" title="Remove from Cart" class="remove-item"><i class="fa fa-trash"></i></a></span>
      </div>
      <div
        class="cart-item-manifest cart-item-manifest-trip clearfix"
        v-for="ticket in getTripTickets(trip.from, trip.to)"
        :key="ticket.operationId + ticket.routeId"
      >
        <div class="cart-item-manifest-list">
          <p class="cart-item-manifest--heading">
            <strong
              >{{ ticket.from }} {{ $t("tocart") }} {{ ticket.to }}</strong
            >
            - {{ ticket.date }}
          </p>
          <ul class="list-unstyled">
            <li
              v-for="(passenger, index) in ticket.passengers"
              :key="
                passenger.fareClassId +
                index +
                passenger.firstName +
                passenger.lastName
              "
            >
              {{ passenger.firstName }} {{ passenger.lastName }} ({{
                passenger.fare
              }}
              - {{ passenger.fareClassName }})
              <span class="pull-right">{{ passenger.displayTotal }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="cart-item-details collapse"
        :id="'cart-trip-' + index"
        role="tabpanel"
      >
        <segmentDetails :trip="trip" fareClasses :class="'fareclass-'" />
      </div>
    </div>
    <div class="cart-fees">
      <div
        class="cart-item-toggle"
        role="button"
        data-toggle="collapse"
        data-target="#cart-item-fees"
        aria-expanded="false"
        aria-controls="cart-item-fees"
      >
        <span class="cart-item--text">{{ $t("fees") }}</span>
        <span class="cart-item--price pull-right">{{
          cartInfo.fees | totalTaxes
        }}</span>
      </div>

      <div
        class="cart-item-details collapse"
        id="cart-item-fees"
        role="tabpanel"
      >
        <ul class="list-unstyled">
          <li v-for="fee in cartInfo.fees" :key="fee.code">
            {{ fee.name }} x {{ fee.qty }}
            <span class="pull-right">{{ fee.total }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="cart-taxes">
      <div
        class="cart-item-toggle"
        role="button"
        data-toggle="collapse"
        data-target="#cart-item-taxes"
        aria-expanded="false"
        aria-controls="cart-item-taxes"
      >
        <span class="cart-item--text">{{ $t("taxes") }}</span>
        <span class="cart-item--price pull-right">{{
          cartInfo.taxes | totalTaxes
        }}</span>
      </div>

      <div
        class="cart-item-details collapse"
        id="cart-item-taxes"
        role="tabpanel"
      >
        <ul class="list-unstyled">
          <li v-for="tax in cartInfo.taxes" :key="tax.name">
            {{ tax.name }} ({{ tax.value }})
            <span class="pull-right">{{ tax.total }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="cart-item-total">
      <p>
        <span class="cart-item--text">{{ $t("total") }}</span>
        <span class="cart-item--price pull-right">{{
          cartInfo.displayTotal
        }}</span>
      </p>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import segmentDetails from "../components/segmentDetails.vue";
export default {
  name: "cartItemsDetails",
  components: {
    segmentDetails,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    cartInfo() {
      return this.$store.state.cart;
    },
    productIcon() {
      return this.$store.state.current_product.icon;
    },
    filterdCartTrips(){
      let tripFroms = this.cartInfo.items.tickets.map(ticket => { return ticket.from + ticket.departureTime });
      let trips = this.$store.state.cartTrips.filter((trip) => tripFroms.includes(trip.from+trip.departure));
      return trips.slice(0,this.cartInfo.items.tickets.length);
    },
    ...mapState(["departureTripId", "trips", "cartTrips", "products"]),
  },
  methods: {
    getTripDetails: function (from, to, dateAtOrigin) {
      //console.log("cart trips", this.cartTrips);
      let selectedTrip = this.cartTrips.filter(function (trip) {
        return (
          trip.from === from && trip.segments[0].manifestDate == dateAtOrigin
        );
      });
      return selectedTrip[0];
    },
    getTripTickets: function (from, to) {
      //console.log("cart trips", this.cartTrips);
      let selectedTickets = this.cartInfo.items.tickets.filter(function (trip) {
        return trip.journeyFrom === from && trip.journeyTo === to;
      });
      return selectedTickets;
    },
    getTripTicketsProductIcon: function (from, to) {
      //console.log("cart trips", this.cartTrips);
      let selectedTickets = this.cartInfo.items.tickets.filter(function (trip) {
        return trip.journeyFrom === from && trip.journeyTo === to;
      });
      let tripProduct = this.products.filter(function (product) {
        return product._id == selectedTickets[0].productId;
      });
      return tripProduct[0].icon;
    },
    removeFromCart: function(operationId){
      return this.$store.dispatch("removeFromCart", operationId).then(()=>{
        if (this.cartInfo.displayTotal == '0.00'){
          this.$router.push("/");
        }
      });
    }
  },
  filters: {
    totalPrice: function (fares) {
      return fares
        .reduce(function (a, b) {
          return Number(a) + Number(b["displayTotal"]);
        }, 0)
        .toFixed(2);
    },
    totalTaxes: function (taxes) {
      return taxes
        .reduce(function (a, b) {
          return Number(a) + Number(b["total"]);
        }, 0)
        .toFixed(2);
    },
  },
};
</script>
<style lang="scss">
.cart-item-toggle {
  margin-top: 10px;
  padding: 4px 0px;
  position: relative;

  &::before {
    content: "";
    background: url('../assets/cart-arrow.svg') no-repeat center left;
    width: 30px;
    height: 30px;
    display: inline-block;
    vertical-align: middle;
    transform: rotate(90deg);
    background-size: 30px;
  }
  &[aria-expanded="false"] {
    &::before {
      content: "";
      display: inline-block;
      vertical-align: middle;
      transform: rotate(0deg);
    }
  }
  &::after {
    bottom: 10px;
    right: 0px;
    position: absolute;
    content: "";
    display: block;
    width: 95%;
    border-bottom: 2px dashed #febc11;
  }
}
.remove-item{
  color: #fff;
  background-color:#cb1700;
  padding:5px 10px; 
  border-radius: 5px;
  &:hover{
    background-color:#00285e;
    color:#fff;
  }
}
.cart-item--text-parent {
  font-size: 21px;
  position: relative;
  z-index: 1;
  font-weight: bold;
  background-color: #fff;
  color: #757070;
}
.cart-item--text,
.cart-item--price {
  position: relative;
  z-index: 1;
  font-weight: bold;
  background-color: #fff;
  padding-left: 20px;
  font-size: 21px;
  color: #757070;
}
.cart-item--text {
  padding-right: 20px;
  small {
    font-size: 15px;
    padding-left: 15px;
  }
}
.cart-item-total {
  padding-left: 25px;
  margin-top: 20px;
  padding-top: 10px;
  border-top: 3px solid #febc11;
}
.cart-item-manifest {
  margin-left: 15px;
  margin-right: 15px;
  //border: 1px solid #cecece;
  border-bottom: 0px;
  padding: 15px 0px;
  font-size: 15px;
  .cart-item-manifest-list {
    width: 45%;
    margin: 0 auto;
  }
  .cart-item-manifest--heading{
    color:#757070;
  }
}
.cart-item-manifest-trip .cart-item-manifest-list {
  margin: 0px 20px;
}
.cart-item-itinirary {
  clear: both;
}
</style>